// extracted by mini-css-extract-plugin
export default {"videoModal":"VideoModal_videoModal__Ruj0l"};